import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import {SharedTranslateModule} from 'shared/shared-translate.module';
import {CommonSharedModule} from '@modules/activities/core/shared-components/common-shared.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {DragulaModule} from 'ng2-dragula';
import {ActivitiesPipesModule} from '@modules/activities/core/pipes/activitiesPipes.module';
import {VideoEditorComponent} from '@modules/activities/core/editor-components/video-editor/video-editor.component';
import {ShortAnswerMultiEditorComponent} from '@modules/activities/core/editor-components/short-answer-multi-editor/short-answer-multi-editor.component';
import {VideoMarkersComponent} from '@modules/activities/core/editor-components/video-editor/video-markers/video-markers.component';
import {SharedModule} from 'shared/shared.module';
import {MultiEditorComponent} from './multi-editor/multi-editor.component';
import {RouterModule, Routes} from '@angular/router';
import { MultimediaEditorComponent } from './multimedia-editor/multimedia-editor.component';
import { AddMediaModalComponent } from './multimedia-editor/add-media-modal/add-media-modal.component';
import {NgxFileDropModule} from 'ngx-file-drop';
import { AddTextModalComponent } from './multimedia-editor/add-text-modal/add-text-modal.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import { ToolEditorComponent } from './tool-editor/tool-editor.component';

const routes: Routes = [{
    path: 'multi/:subLessonId',
    children : [{
        path: '',
        component: MultiEditorComponent,
    }, {
        path: 'multimedia/:activityId',
        component: MultimediaEditorComponent
    }]
}];

@NgModule({
    imports: [
        ActivitiesPipesModule,
        CKEditorModule,
        CommonModule,
        CommonSharedModule,
        DragulaModule,
        // NgxFileDropModule,
        FuseSharedModule,
        MatButtonModule,
        MatCardModule,
        MatGridListModule,
        MatIconModule,
        MatProgressSpinnerModule,
        RouterModule.forChild(routes),
        SharedModule,
        SharedTranslateModule,
        NgxFileDropModule,
    ],
    declarations: [
        AddMediaModalComponent,
        AddTextModalComponent,
        MultiEditorComponent,
        MultimediaEditorComponent,
        ShortAnswerMultiEditorComponent,
        VideoEditorComponent,
        VideoMarkersComponent,
        ToolEditorComponent,
    ],
    exports: []
})
export class EditorsModule {
}
